<template>

<div class="rules-component">

	<top-bar></top-bar>

	<div class="container">

		<h3>Manage rules</h3>
		<div v-show="$store.state.rules.message" id="error-message"
			 class="alert alert-danger" role="alert">
			Error: {{$store.state.rules.message}}
		</div>

		<table class="table tabe-hover table-striped">
			<thead>
				<tr>
					<th></th>
					<th>Role</th>
					<th>Pattern</th>
					<th>Permission</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="rule in $store.state.rules.rules">
					<td>
						<a href="#"
						   @click.prevent="dropRule(rule)">
						   <span class="glyphicon glyphicon-remove"></span>
						</a>
					</td>
					<td>{{rule.role}}</td>
					<td><code>{{rule.pattern}}</code></td>
					<td>
						<span :class="beautifyPermission(rule.permission).icon"></span>
						<span style="padding-left: 1rem;">{{beautifyPermission(rule.permission).label}}</span>
					</td>
				</tr>
			</tbody>
		</table>

		<h3>Add new rule</h3>

		<div class="row">

			<div class="col-sm-3">
				<select v-model="role" class="form-control">
				  <option v-for="role in $store.state.rules.roles">
				    {{ role }}
				  </option>
				</select>
			</div>

			<div class="col-sm-4">
				<input class="form-control" type="text" v-model="pattern" placeholder="Regular Expression">
			</div>

			<div class="col-sm-1">
				<select v-model="permission" class="form-control">
				  <option v-for="perm in permissions">
				    {{ perm }}
				  </option>
				</select>
			</div>

			<div class="col-sm-1">
				<input class="form-control btn btn-primary" type="button" @click="addRule" value="Add">
			</div>

		</div>

	</div>
</div>

</template>
<script type="text/javascript">
	import TopBar from './TopBar.vue'
	export default {
		components: {
			'top-bar': TopBar
		},
		data(){
			return {
				role: '',
				permission: '',
				pattern: '',
				permissions: ['r', 'rw']
			}
		},
		methods: {
			beautifyPermission(perm){
				if (perm == 'r') {
					return {label: 'Read Only', icon: 'glyphicon glyphicon-eye-open'}
				} else if (perm == 'rw') {
					return {label: 'Read + Write', icon: 'glyphicon glyphicon-pencil'}
				}
			},
			dropRule(rule){
				this.$store.dispatch('dropRule', rule)
			},
			addRule(){
				var rule = {
					role: this.role,
					permission: this.permission,
					pattern: this.pattern
				}
				this.$store.dispatch('addRule', rule)
				this.role = ''
				this.permission = ''
				this.pattern = ''
			}
		},
		mounted() {
			this.$store.dispatch('fetchRules')
		}
	}
</script>
